import React, { useEffect, useState, useCallback } from 'react';
import { operationLogAPI } from '../../services/api';
import { Loading, Alert, Input, Button } from '../../components/common';
import './AdminPages.css';

const OperationLogsPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [filters, setFilters] = useState({
    action: '',
    target_type: '',
    actor: '',
    start_date: '',
    end_date: '',
  });

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await operationLogAPI.list(filters);
      setLogs(res.data.results || res.data);
    } catch (err) {
      setMessage({ type: 'error', text: '获取操作记录失败' });
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  };

  return (
    <div className="admin-page">
      <div className="page-header">
        <div>
          <h1>操作记录</h1>
          <p>查看管理员、部门经理等的关键变更操作</p>
        </div>
      </div>

      {message.text && (
        <Alert
          type={message.type}
          message={message.text}
          onClose={() => setMessage({ type: '', text: '' })}
        />
      )}

      <div className="admin-toolbar">
        <form
          className="search-form"
          onSubmit={(e) => {
            e.preventDefault();
            fetchData();
          }}
        >
          <Input
            placeholder="操作类型 (user_update/department_update...)"
            value={filters.action}
            onChange={(e) => setFilters({ ...filters, action: e.target.value })}
            fullWidth={false}
          />
          <Input
            placeholder="目标类型 (user/department)"
            value={filters.target_type}
            onChange={(e) => setFilters({ ...filters, target_type: e.target.value })}
            fullWidth={false}
          />
          <Input
            placeholder="操作人ID"
            value={filters.actor}
            onChange={(e) => setFilters({ ...filters, actor: e.target.value })}
            fullWidth={false}
          />
          <Input
            type="date"
            value={filters.start_date}
            onChange={(e) => setFilters({ ...filters, start_date: e.target.value })}
            fullWidth={false}
          />
          <Input
            type="date"
            value={filters.end_date}
            onChange={(e) => setFilters({ ...filters, end_date: e.target.value })}
            fullWidth={false}
          />
          <Button type="submit" variant="secondary">筛选</Button>
        </form>
      </div>

      {loading ? (
        <Loading fullScreen text="加载中..." />
      ) : (
        <div className="admin-table-wrapper">
          <table className="admin-table">
            <thead>
              <tr>
                <th>操作时间</th>
                <th>操作人</th>
                <th>操作类型</th>
                <th>目标类型</th>
                <th>目标名称</th>
                <th>详情</th>
              </tr>
            </thead>
            <tbody>
              {logs.length > 0 ? (
                logs.map((log) => (
                  <tr key={log.id}>
                    <td>{formatDate(log.created_at)}</td>
                    <td>{log.actor_name || '-'}</td>
                    <td>{log.action}</td>
                    <td>{log.target_type || '-'}</td>
                    <td>{log.target_name || '-'}</td>
                    <td style={{ maxWidth: 320, whiteSpace: 'pre-wrap' }}>{log.detail || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="empty-cell">暂无操作记录</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default OperationLogsPage;

